import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core';

import { RootState } from 'store/rootReducer';
import {
  selectGroupedProcessDefinitions,
  selectProcessDefinitionsIsLoading,
  selectProcessDefinitionsError,
  getGroupedProcessDefinitionsRequest,
  startProcessRequest,
} from 'store/processDefinitions';
import { selectCurrentUserInfo } from 'store/currentUser';
import { ProcessDefinitionGroupData } from '#shared/types/processDefinition';
import { ErrorInfo } from '#shared/types/common';
import { withRouter } from 'react-router-dom';
import { CurrentUser } from '#shared/types/user';
import ProcessList from './ProcessListPage';
import styles from './ProcessListPage.styles';

export interface PropsFromState {
  processGroupData: ProcessDefinitionGroupData;
  isLoading: boolean;
  userInfo: CurrentUser | null;
  error?: ErrorInfo
}

export interface DispatchProps {
  getProcessGroupData: typeof getGroupedProcessDefinitionsRequest;
  startProcess: typeof startProcessRequest;
}

function mapStateToProps(state: RootState): PropsFromState {
  return {
    processGroupData: selectGroupedProcessDefinitions(state),
    userInfo: selectCurrentUserInfo(state),
    isLoading: selectProcessDefinitionsIsLoading(state),
    error: selectProcessDefinitionsError(state),
  };
}

const mapDispatchToProps: DispatchProps = {
  getProcessGroupData: getGroupedProcessDefinitionsRequest,
  startProcess: startProcessRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(
  withTranslation('pages')(
    withRouter(
      withStyles(styles)(ProcessList),
    ),
  ),
);
